module.exports = __webpack_public_path__ + "img/facebook_og.89ae872b.jpg";